import { useEffect, useState } from 'react'
import TarjetScort from '../hooks/TarjetScort';
import { AuthServices } from '../util/authServices';

const Preliminar = ({ setUserSession, setViewAdminZone, userSession, setIdProcesamientoScort, setScortService, setCargando, toast }) => {

    const [scortObjectList, setScortObjectList] = useState([])
    const [stateModalDeleteScort, setStateModalDeleteScort] = useState(false)
    const [stateModalActionScort, setStateModalActionScort] = useState(false)
    const [stateModalResetPassScort, setStateModalResetPassScort] = useState(false)
    const [actionScort, setActionScort] = useState('')
    const [labelActionScort, setLabelActionScort] = useState('')
    const [scortDelete, setScortDelete] = useState({})
    const [scortAction, setScortAction] = useState({})
    const [identificaEscort, setIdentificaEscort] = useState('')

    useEffect(() => {
        obtieneListaScorts()
    }, [])

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const editarScort = (scortObjet) => {
        setIdProcesamientoScort(scortObjet.idProcesamiento)
        setViewAdminZone('REGISTRA')
    }

    const activaScortAction = (scortObjet) => {
        setStateModalActionScort(true)
        setActionScort("ACTIVACION")
        setLabelActionScort(scortObjet.activo ? "Desactivar" : "Activar")
        setScortAction(scortObjet)
    }

    const disponibilizaScortAction = (scortObjet) => {
        setStateModalActionScort(true)
        setActionScort("DISPONIBILIZA")
        setLabelActionScort(scortObjet.disponible ? "Sacar de disponibilidad" : "Disponibilizar")
        setScortAction(scortObjet)
    }

    const eliminaScort = (scortObjet) => {
        setStateModalDeleteScort(true)
        setScortDelete(scortObjet)
    }

    const resetPassScort = (scortObjet) => {
        setStateModalResetPassScort(true)
        setScortAction(scortObjet)
    }

    const registrarServicio = (scortObjet) => {
        setScortService(scortObjet)
        setViewAdminZone('REGISTRO_SERVICIOS')
    }

    const cancelaActionScort = () => {
        setActionScort("")
        setStateModalActionScort(false)
        setScortAction({})
    }

    const cancelaEliminaScort = () => {
        setStateModalDeleteScort(false)
        setScortDelete({})
    }

    const cancelaResetPassScort = () => {
        setStateModalResetPassScort(false)
        setScortAction({})
    }

    const confirmaActionScort = () => {
        setStateModalActionScort(false)
        actualizaActionScortService()
    }

    const confirmaEliminaScort = () => {
        setStateModalDeleteScort(false)
        eliminaScortService()
    }

    const confirmaResetPassScort = () => {
        setStateModalResetPassScort(false)
        actualizaPassScortService()
    }

    const displayEliminaEscort = (scortObjet) => {
        if (userSession.role === 'USUARIO_ROOT') {
            return (
                <button className='btn btn-link btn-close-modal' onClick={() => eliminaScort(scortObjet)} >Eliminar</button>
            )
        } else {
            return (
                <></>
            )
        }
    }

    const actualizaActionScortService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "idProcesamiento": scortAction.idProcesamiento,
                "action": actionScort,
                "dateAction": new Date()
            }
            const response = await authServices.requestPost(body, 11);
            const { estado, mensaje } = response.data;
            if (estado) {
                obtieneListaScorts()
            } else {
                toast(mensaje)
            }
            setCargando(false)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const eliminaScortService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "idProcesamiento": scortDelete.idProcesamiento,
            }
            const response = await authServices.requestPost(body, 10);
            const { estado, mensaje } = response.data;
            if (estado) {
                obtieneListaScorts()
            } else {
                toast(mensaje)
            }
            setCargando(false)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const actualizaPassScortService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuario": scortAction.cedula,
            }
            const response = await authServices.requestPost(body, 9);
            const { mensaje } = response.data;
            toast(mensaje)
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const obtieneListaScorts = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "origen": "preliminar",
            }
            const response = await authServices.requestPost(body, 1);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setScortObjectList(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const obtieneScortporCedula = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "cedula": identificaEscort,
            }
            const response = await authServices.requestPost(body, 8);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setScortObjectList(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 control-margin" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('HOME')} >Volver a menú</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                        <div style={{ padding: "10px 0px 0px 12px" }}>
                            <p className='p-label-form'> Buscar por No. de identificación </p>
                        </div>
                        <div className="row m-0">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4" >
                                <input type="text" name='identificaEscort' value={identificaEscort} onChange={(e) => setIdentificaEscort(e.target.value)} className='form-control' autoComplete='off' />
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-8" >
                                <div className='div-boton-filtro-preliminar'>
                                    <button className='btn btn-link btn-close-modal' onClick={() => obtieneScortporCedula()} >Buscar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='hr-report mt-3' />
                    {
                        scortObjectList?.map((scortObjet, i) => {
                            return (

                                <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-4 div-actions-preliminar-padre" >
                                    <div className='div-actions-preliminar-actions-padre'>
                                        <div className='div-actions-preliminar-actions'>
                                            <p>Activo</p>
                                            <div className={scortObjet.activo ? 'div-container-select-padre-active' : 'div-container-select-padre'} onClick={() => activaScortAction(scortObjet)} >
                                                <div className={scortObjet.activo ? 'div-container-select-active' : 'div-container-select'} ></div>
                                            </div>
                                        </div>
                                        <div className='div-actions-preliminar-actions'>
                                            <p>Disponible</p>
                                            <div className={scortObjet.disponible ? 'div-container-select-padre-active' : 'div-container-select-padre'} onClick={() => disponibilizaScortAction(scortObjet)} >
                                                <div className={scortObjet.disponible ? 'div-container-select-active' : 'div-container-select'}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='div-actions-preliminar'>
                                        <div>
                                            <button className='btn btn-link btn-close-modal' onClick={() => editarScort(scortObjet)} >Editar</button>
                                            {
                                                displayEliminaEscort(scortObjet)
                                            }
                                        </div>
                                        <p>{scortObjet.cedula} </p>
                                    </div>
                                    <div className='div-actions-preliminar'>
                                        <button className='btn btn-link btn-close-modal' onClick={() => resetPassScort(scortObjet)} >Reset Pass</button>
                                        <p>{scortObjet.telefonoPersonal} </p>
                                    </div>
                                    <div className='div-actions-preliminar'>
                                        <button className='btn btn-link btn-close-modal' onClick={() => registrarServicio(scortObjet)} >Gestion Servicios</button>
                                    </div>
                                    <TarjetScort scortObjet={scortObjet} preView='preliminar' />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="mb-5" ></div>
            {
                stateModalDeleteScort ?
                    <div className='div-cargando-active'>
                        <div className='div-gift-element'>
                            <div className='div-modal-elimina-scort'>
                                <div className='mb-4'>
                                    <h3>Eliminar Scort</h3>
                                    <br />
                                    <p >Seguro de eliminar la Scort: <font className='parrafo-elimina-scort '> {scortDelete.nombre} {scortDelete.apellido} </font>  </p>
                                </div>
                                <div className='div-butoms-delete-scort'>
                                    <button className='btn btn-link btn-close-modal' onClick={() => confirmaEliminaScort()} >Aceptar</button>
                                    <button className='btn btn-link btn-close-modal' onClick={() => cancelaEliminaScort()} >Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }
            {
                stateModalActionScort ?
                    <div className='div-cargando-active'>
                        <div className='div-gift-element'>
                            <div className='div-modal-elimina-scort'>
                                <div className='mb-4'>
                                    <h3>Acciones Scort</h3>
                                    <br />
                                    <p >Seguro desea
                                        <font className='parrafo-elimina-scort '> {labelActionScort}</font> la Scort:
                                        <font className='parrafo-elimina-scort '> {scortAction.nombre} {scortAction.apellido}
                                        </font>
                                    </p>
                                </div>
                                <div className='div-butoms-delete-scort'>
                                    <button className='btn btn-link btn-close-modal' onClick={() => confirmaActionScort()} >Aceptar</button>
                                    <button className='btn btn-link btn-close-modal' onClick={() => cancelaActionScort()} >Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }
            {
                stateModalResetPassScort ?
                    <div className='div-cargando-active'>
                        <div className='div-gift-element'>
                            <div className='div-modal-elimina-scort'>
                                <div className='mb-4'>
                                    <h3>Reiniciar Contraseña Scort</h3>
                                    <br />
                                    <p >Seguro de Reiniciar la contraseña para la Scort: <font className='parrafo-elimina-scort '> {scortAction.nombre} {scortAction.apellido} </font>  </p>
                                </div>
                                <div className='div-butoms-delete-scort'>
                                    <button className='btn btn-link btn-close-modal' onClick={() => confirmaResetPassScort()} >Aceptar</button>
                                    <button className='btn btn-link btn-close-modal' onClick={() => cancelaResetPassScort()} >Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }


        </>
    )
}

export default Preliminar